module.exports = __webpack_public_path__ + "img/biter-attack-mask1.738f252e.png";